import { isNumber } from 'lodash';

export const isValidDivisor = (value: any) => isNumber(value) && value !== 0;

export const divide = (dividend: number, divisor: any) => {
  if (isValidDivisor(divisor)) {
    return dividend / divisor;
  }
  return 0;
};

export const roundToTwoDecimals = (value: number) => Math.round((value + Number.EPSILON) * 100) / 100;

export const roundToFourDecimals = (value: number) => Math.round((value + Number.EPSILON) * 10000) / 10000;

export const truncateNumber = (value: number, decimalScale: number) => {
  return Math.trunc((value + Number.EPSILON) * Math.pow(10, decimalScale)) / Math.pow(10, decimalScale);
};
